export const getErrorRouteColor = () => {
    return 'rgb(191, 91, 91)';
}
